import { bhajanApi } from '../../api/bhajans';
import { createCategorySlice } from './categorySlice';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'bhajans',
  api: bhajanApi,
  hasPublish: true,
});

const categoryFactory = createCategorySlice({
  name: 'bhajanCategories',
  api: bhajanApi.categories,
});

export const bhajanReducer = slice.reducer;
export const bhajanActions = actions;

export const bhajanCategoryReducer = categoryFactory.slice.reducer;
export const bhajanCategoryActions = categoryFactory.actions;

export const selectBhajans = (state) => state.bhajans.items;
export const selectBhajansStatus = (state) => state.bhajans.status;
export const selectBhajanCategories = (state) => state.bhajanCategories.items;
